
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/request_boxes",
      function () {
        return require("private-next-pages/companies/request_boxes/index.tsx");
      }
    ]);
  